/* eslint-disable */
import Cookie from "js-cookie";
import helpers from "./helpers";

const modalCookieName = "showTrainingSelectorModal";

export default (function() {
  let overlay;
  let modal;
  let haveLocationData = false;
  let showTrainingSelectorModal = false;
  const body = document.querySelector("body");

  return {
    init() {
      overlay = document.getElementById("training-selector-modal");
      if (overlay == null) return;
      modal = document.getElementById("modal");
      const closeButton = modal.querySelector("#modal-close");
      showTrainingSelectorModal = Cookie.get(modalCookieName) !== "false";

      if (
        showTrainingSelectorModal === true
      ) {
          setTimeout(()=> {this.showModal(modal)}, 10000);
        }

      overlay.addEventListener("click", ({ clientX, clientY }) => {
        // check if modal was clicked and not overlay
        const { top, bottom, left, right } = modal.getBoundingClientRect();
        if (
          clientY > top &&
          clientY < bottom &&
          clientX > left &&
          clientX < right
        ) {
          // click was inside modal so do nothing
          return;
        }

        // click was outside modal so close it
        this.closeModal();
      });

      closeButton.addEventListener("click", () => {
        this.closeModal();
      });

        this.fetchUserLocation();
    },
    showModal() {
      showTrainingSelectorModal = overlay.hasAttribute('google-optimise-training');
      if (showTrainingSelectorModal && haveLocationData) {
        this.setupFocusTrap();
        this.initEscapeKeyListener();
        helpers.removeClass(overlay, "u-hide");
        const body = document.querySelector("body");
        helpers.addClass(body, "stop-scrolling");
      }
    },
    closeModal() {
      Cookie.set(modalCookieName, "false");
      showTrainingSelectorModal = false;
      helpers.addClass(overlay, "u-hide");
      helpers.removeClass(body, "stop-scrolling");
    },
    fetchUserLocation() {
      const url = overlay.getAttribute("get-location-url");
      fetch(url, {
        method: "GET"
      })
        .then(response => response.json())
        .then(json => {
            haveLocationData = true;
            this.renderOptions(json);
        })
        .catch(error => {});
    },
    renderOptions(json) {
      if (json.showPopup === false) {
        showTrainingSelectorModal = false;
        return;
      }

      this.renderHeading(json.heading);

      this.renderCountry(json.primaryContent, json.primaryLink);

      this.renderLanguageOptions(json.secondaryLinks);
    },
    renderHeading(text) {
      const heading = modal.querySelector("#modal-heading");
      heading.innerHTML = text;
    },
    renderCountry(heading, link) {
      modal.querySelector("#modal-country-heading").innerHTML = heading;

      const countryButtonContainer = modal.querySelector(
        "#modal-country-container"
      );

      let anchorEl;

      if(link.linkUrl === null){
        anchorEl = document.createElement("span");
      }else{
        anchorEl = document.createElement("a");
        anchorEl.href = link.linkUrl;
      }

      helpers.addClass(anchorEl, "btn btn--small");

      const anchorText = document.createElement("span");
      helpers.addClass(anchorText, "btn__text");
      anchorText.innerHTML = link.linkText;

      countryButtonContainer.appendChild(anchorEl);
      anchorEl.appendChild(anchorText);
    },
    renderLanguageOptions(links) {
      if (links === null) return;

      const languageHeading = modal.querySelector("#modal-language-heading");
      const languageButtonContainer = modal.querySelector(
        "#modal-language-container"
      );

      links.forEach(link => {
        const anchorEl = document.createElement("a");
        helpers.addClass(anchorEl, "btn btn--small btn--ghost");
        anchorEl.href = link.linkUrl;

        const anchorText = document.createElement("span");
        helpers.addClass(anchorText, "btn__text");
        anchorText.innerHTML = link.linkText;

        languageButtonContainer.appendChild(anchorEl);
        anchorEl.appendChild(anchorText);
      });

      helpers.removeClass(languageHeading, "u-hide");
      helpers.removeClass(languageButtonContainer, "u-hide");
    },
    setupFocusTrap() {
      modal.focus();

      const focusableElements = "a, #modal-close";

      const firstFocusableElement = modal.querySelectorAll(
        focusableElements
      )[0]; // get first element to be focused inside modal
      const focusableContent = modal.querySelectorAll(focusableElements);

      const lastFocusableElement =
        focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

      document.addEventListener("keydown", function(e) {
        const isTabPressed = e.key === "Tab" || e.keyCode === 9;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          // if shift key pressed for shift + tab combination
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus(); // add focus for the last focusable element
            e.preventDefault();
          }
        } else {
          // if tab key is pressed
          if (document.activeElement === lastFocusableElement) {
            // if focused has reached to last focusable element then focus first focusable element after pressing tab
            firstFocusableElement.focus(); // add focus for the first focusable element
            e.preventDefault();
          }
        }
      });
    },
    initEscapeKeyListener() {
      document.addEventListener("keydown", event => {
        const isEscapePress =
          event.key === "Escape" || event.key === "Esc" || event.keyCode === 27;

        if (isEscapePress === false) return;

        this.closeModal();
      });
    }
  };
})();
